import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './stores'
import 'vuetify/dist/vuetify.min.css'
import Vuetify from 'vuetify'
import './registerServiceWorker'
import firebase from 'firebase'
import { config } from "./firebaseConfig";
import axios from 'axios'
import VueGeolocation from 'vue-geolocation-api'
import * as VueGoogleMaps from "vue2-google-maps";
import "@/plugins/echarts";
import { stage } from '../appConfig';
import { branchMaster } from '../appConfig';
import { consumerKey } from '../appConfig';
import { consumerSecret } from '../appConfig';
import { tokenId } from '../appConfig';
import { tokenSecret } from '../appConfig';
import { contentType } from '../appConfig';
import { itemMasterNonInventory } from '../appConfig';
import { smsAuthorization } from '../appConfig';
import { smsUrl } from '../appConfig';
import { clientUrl } from '../appConfig';
import { branchUrl } from '../appConfig';
import { adminUrl } from '../appConfig';
import { mailerUrl } from '../appConfig';
import { subAccount } from '../appConfig';

Vue.use(VueGeolocation);
Vue.use(require('vue-moment'));
export const firebaseApp = firebase.initializeApp(config);
export const db = firebase.firestore();
export const storage = firebase.storage();

firebase.functions().useFunctionsEmulator('http://127.0.0.1:5000')

navigator.serviceWorker.register('/service-worker.js', {
	scope: '/app/'
});

Vue.use(VueGoogleMaps, {
	load: {
		key: "AIzaSyDHAjcezNBpAbyyj9PwSnH5fplYE1o9cOE",
		libraries: "places",
	},
});

db.settings({
  timestampsInSnapshots: true
});

Vue.prototype.$stage = stage;
Vue.prototype.$branchMaster = branchMaster;
Vue.prototype.$consumerKey = consumerKey;
Vue.prototype.$consumerSecret = consumerSecret;
Vue.prototype.$tokenId = tokenId;
Vue.prototype.$tokenSecret = tokenSecret;
Vue.prototype.$smsUrl = smsUrl;
Vue.prototype.$smsAuthorization = smsAuthorization;
Vue.prototype.$contentType = contentType;
Vue.prototype.$axios = axios;
Vue.prototype.$itemMasterNonInventory = itemMasterNonInventory;
Vue.prototype.$clientUrl = clientUrl;
Vue.prototype.$branchUrl = branchUrl;
Vue.prototype.$adminUrl = adminUrl;
Vue.prototype.$mailerUrl = mailerUrl;
Vue.prototype.$subAccount = subAccount;
Vue.use(Vuetify)
Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
	if(!to.meta.public){
		if(store.getters.auth) {
			next();
		} else {
			localStorage.setItem("returnURL", window.location.href)
			router.push("/login");
		}
	} else {
		next();	
	}
})


new Vue({
	router,
	store,
	render: h => h(App)
  }).$mount('#app')